import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- entities
import { OrderMenuPart, OrderProduct } from 'PMT/entities/order';
import { MenuPart, Product } from 'PMT/entities/menu';

// -- views
import OrderProductView from './OrderProductView';

export default class OrderMenuPartView extends Component {

  static propTypes = {
    orderMenuPart: PropTypes.instanceOf(OrderMenuPart).isRequired,
    currencyCode: PropTypes.string,

  };

  get orderMenuPart(): OrderMenuPart {
    return this.props.orderMenuPart;
  }

  get currencyCode(): string {
    return this.props.currencyCode;
  }

  //
  // Renderers
  //

  renderName() {
    return (
      <div className="order_menu_part_view__name">
        {this.orderMenuPart.name}
      </div>
    )
  }

  renderProducts() {
    // Note: we don't trust the orderId as key because the other fronts set it, and some duplicates
    // can appears

    return (
      <div className="order_menu_part_view__products">
        {this.orderMenuPart.products.map((orderProduct: OrderProduct, index) => {
          return (
            <OrderProductView
              key={`${orderProduct.orderId}_${index}`}
              orderProduct={orderProduct}
              onMenu
              currencyCode={this.currencyCode}
            />
          );
        })}
      </div>
    );
  }

  render() {
    return (
      <div className="order_menu_part_view">
        {/* {this.renderName()} */}
        {this.renderProducts()}
      </div>
    );
  }

}
